import gearHead from "./assets/json/parameters/GearInfoHead.json"
import { SkillIDs, getGearLabel } from "./Utils"

export const defaultGearList = {
    HaveGearHeadMap: {},
    HaveGearClothesMap: {},
    HaveGearShoesMap: {},
}

export const defaultImportData = {
    UserKey: "",
    H: 0,
    LastImported: 0,
    CloudRandomSet: {
        Map: {
            MissionDrone: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            CardPack: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RewardRandomPool_Gear_Head: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RewardRandomPool_Gear_Shoes: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RewardRandomPool_Emote: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            Lot: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RewardRandomPool_LockerFigure: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            MysteryBox: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RandomDrinkTicket: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RandomFoodTicket: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RewardRandomPool_Gear_Clothes: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            LotFest: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RewardRandomPool_LockerSticker: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RewardRandomPool_NamePlateBg: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            Vendor: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
            RewardRandomPool_Byname: {
                Context1: 0,
                Context2: 0,
                Context3: 0,
                Context4: 0,
            },
        },
    },
}

export const defaultSchedule = {
    data: {
        regularSchedules: {
            nodes: [],
        },
        bankaraSchedules: {
            nodes: [],
        },
        xSchedules: {
            nodes: [],
        },
        leagueSchedules: {
            nodes: [],
        },
        coopGroupingSchedule: {
            regularSchedules: {
                nodes: [],
            },
            bigRunSchedules: { nodes: [] },
            teamContestSchedules: { nodes: [] },
        },
        festSchedules: {
            nodes: [],
        },
        currentFest: null,
        currentPlayer: {},
        vsStages: {
            nodes: [],
        },
    },
}

export const defaultSRGear = {
    "2022-11-01T00:00:00Z": {
        past: [
            "https://leanny.github.io/splat3/images/gear/Hed_COP110.png",
            "https://leanny.github.io/splat3/images/gear/Hed_COP111.png",
        ],

        current: "https://leanny.github.io/splat3/images/gear/Hed_COP115.png",
    },
    "2022-12-01T00:00:00Z": {
        past: [
            "https://leanny.github.io/splat3/images/gear/Hed_COP110.png",
            "https://leanny.github.io/splat3/images/gear/Hed_COP111.png",
            "https://leanny.github.io/splat3/images/gear/Hed_COP115.png",
        ],

        current: "https://leanny.github.io/splat3/images/gear/Hed_COP113.png",
    },
}

export const defaultGachaData = start_reward => [{ Num: 1, Value: start_reward }]
export const defaultBynameData = (sub, adj) => [{ Num: 1, ValueSub: sub, ValueAdj: adj }]
export const defaultNameplateData = elem => [{ Num: 1, Value: elem }]

export const defaultMurchData = t => [
    {
        gearSelected: { value: gearHead[0], type: 0, label: getGearLabel(t, gearHead[0], 0) },
        ordered: { main: 255, subs: [255, 255, 255] },
        received: { main: SkillIDs[gearHead[0].Skill], subs: [255, 255, 255] },
        receivedGear: true,
    },
]

export const defaultProfile = {
    BadgeList: [],
    GoodsMap: {},
    BynameAdjectiveMap: {},
    BynameSubjectMap: {},
    NamePlateBgMap: [],
    SkillChipMap: {},
    Versus: {
        WinCountByRule: {},
        WinCountBySpecial: {},
        WinCountByTclAtk: 0,
        WinCountByTclDef: 0,
    },
    Coop: {
        BossKillNumMap: {},
        RareEnemyKillNumMap: {},
    },
    Level: 1,
    EmoteMap: {},
}

export const defaultImportedMatches = { Coop: [], Versus: [] }
